import { render, staticRenderFns } from "./sharePopup.vue?vue&type=template&id=76bf6f18&scoped=true"
import script from "./sharePopup.vue?vue&type=script&lang=js"
export * from "./sharePopup.vue?vue&type=script&lang=js"
import style0 from "./sharePopup.vue?vue&type=style&index=0&id=76bf6f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bf6f18",
  null
  
)

export default component.exports